module.exports = __webpack_public_path__ + "media/images/new_home/product-3-750b97ae687e5e1529091fcb43c5adc2.png";